
import { useToast } from "@/hooks/use-toast";
import { logger } from '@/utils/logger';

export const useTodoCoreOperations = (addCloudTodo: any, toggleCloudTodo: any) => {
  const { toast } = useToast();

  const addTodo = async ({ goalTitle, todoText, todoDueDate }: { goalTitle: string, todoText: string, todoDueDate: string }) => {
    try {
      logger.debug(`[todoCore.addTodo] Text: "${todoText}" | Goal: "${goalTitle}" | Date: "${todoDueDate}"`);
      
      if (!todoText) {
        logger.error(`[todoCore.addTodo] Empty todo text`);
        return Promise.reject(new Error("Todo text cannot be empty"));
      }
      
      if (todoText === goalTitle) {
        logger.warn(`[todoCore.addTodo] Todo text equals goal title`);
      }
      
      await addCloudTodo({ goalTitle, todoText, todoDueDate });
      
      logger.debug(`[todoCore.addTodo] Success`);
      return Promise.resolve();
    } catch (error: any) {
      logger.error(`[todoCore.addTodo] ERROR:`, error);
      return Promise.reject(error);
    }
  };

  const toggleTodo = async ({ goalTitle, todoId }: { goalTitle: string, todoId: string }) => {
    try {
      await toggleCloudTodo({ goalTitle, todoId });
      return Promise.resolve();
    } catch (error: any) {
      toast({
        title: "Error toggling todo",
        description: error.message,
        variant: "destructive",
      });
      return Promise.reject(error);
    }
  };

  const deleteTodo = async (
    { goalTitle, todoId }: { goalTitle: string, todoId: string }, 
    deleteCloudTodo: (params: { todoId: string }) => Promise<any>
  ) => {
    try {
      logger.debug(`[todoCore.deleteTodo] Deleting todo: ${todoId}`);
      
      if (typeof todoId !== 'string') {
        logger.error(`[todoCore.deleteTodo] todoId is not a string:`, todoId);
        toast({
          title: "Error deleting todo",
          description: "Invalid todo identifier type",
          variant: "destructive",
        });
        return Promise.reject(new Error("Invalid todo identifier type"));
      }
      
      const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      if (!uuidRegex.test(todoId)) {
        logger.error(`[todoCore.deleteTodo] Invalid todoId format: "${todoId}"`);
        toast({
          title: "Error deleting todo",
          description: "Invalid todo identifier",
          variant: "destructive",
        });
        return Promise.reject(new Error("Invalid todo identifier"));
      }
      
      await deleteCloudTodo({ todoId });
      
      logger.debug(`[todoCore.deleteTodo] Success`);
      
      toast({
        title: "Todo deleted",
        description: "Todo has been deleted successfully.",
      });
      return Promise.resolve();
    } catch (error: any) {
      logger.error(`[todoCore.deleteTodo] ERROR:`, error);
      toast({
        title: "Error deleting todo",
        description: error.message,
        variant: "destructive",
      });
      return Promise.reject(error);
    }
  };

  return {
    addTodo,
    toggleTodo,
    deleteTodo
  };
};
